import { Link } from "react-router-dom";

const green = "#078866";
const ink = "#14241F";
const muted = "#5F706B";

type LiangmuBrandLockupProps = {
  className?: string;
  markSize?: number;
  brandSize?: number;
  taglineSize?: number;
  showTagline?: boolean;
  tagline?: string;
  gap?: number;
  stacked?: boolean;
  brandColor?: string;
  taglineColor?: string;
};

export function LiangmuBrandMark({ size = 36, className = "" }: { size?: number; className?: string }) {
  const radius = Math.max(10, Math.round(size * 0.22));

  return (
    <span
      className={`relative inline-grid shrink-0 place-items-center overflow-hidden shadow-[0_12px_28px_rgba(7,136,102,.24)] ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: "linear-gradient(135deg,#0AA878 0%,#078866 50%,#076A51 100%)",
      }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 64 64" className="h-[78%] w-[78%]" role="img">
        <path d="M19 14v34h29" fill="none" stroke="#FFFFFF" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M39.5 30.5C48 21.5 56 22 56 22c-.5 9.5-7.5 17-17.5 17.5 1.2-4.5 1.4-6.8 1-9Z" fill="#F7FFFC" />
        <path d="M43.8 35.4c2.4-3.7 5.2-6.2 8.4-8.2" fill="none" stroke="#9DE6CD" strokeWidth="2.6" strokeLinecap="round" />
      </svg>
    </span>
  );
}

export function LiangmuBrandLockup({
  className = "",
  markSize = 36,
  brandSize = 24,
  taglineSize = 12,
  showTagline = true,
  tagline = "AI 全域营销增长平台",
  gap = 12,
  stacked = true,
  brandColor = ink,
  taglineColor = muted,
}: LiangmuBrandLockupProps) {
  return (
    <span className={`inline-flex items-center ${className}`} style={{ gap }}>
      <LiangmuBrandMark size={markSize} />
      <span className={`min-w-0 ${stacked ? "flex flex-col" : "inline-flex items-center"}`} style={{ gap: stacked ? 2 : 18 }}>
        <span className="whitespace-nowrap font-black leading-none tracking-normal" style={{ color: brandColor, fontSize: brandSize }}>
          良木AI
        </span>
        {showTagline ? (
          <span className="whitespace-nowrap font-semibold leading-none tracking-[.08em]" style={{ color: taglineColor, fontSize: taglineSize }}>
            {tagline}
          </span>
        ) : null}
      </span>
    </span>
  );
}

export default function LiangmuBrandLogo(props: LiangmuBrandLockupProps & { to?: string }) {
  const { to = "/", ...lockupProps } = props;

  return (
    <Link to={to} className="inline-flex items-center">
      <LiangmuBrandLockup {...lockupProps} />
    </Link>
  );
}
